export const customersQuotes = {
  toyota: {
    content:
      '“Very quickly, our engineers liked what they saw and we asked Scale to ramp 10X throughput in a matter of weeks. Scale’s been able to support the extra throughput request and allowed us to do great research.”',
    profile: 'David Garber',
    position: 'Product Manager, TRI',
    logo: {
      src: '/static/images/pages/homepage/quotes/toyota.svg',
      width: 160,
      height: 80,
      alt: 'Toyota'
    },
    img: {
      src: '/static/img/website/big/customers/cards/toyota.jpg',
      width: 1168,
      height: 600,
      alt: 'Toyota'
    }
  },
  statesTitle: {
    content:
      '“Scale has provided the fuel to put our machine learning systems on overdrive. They make sure the highest quality training data is there in time to meet our aggressive roadmap. Lenders and borrowers will experience faster and more efficient closings sooner as a result.”',
    profile: 'Andy Mahdavi',
    position: 'Chief Data Science Officer, States Title',
    logo: {
      src: '/static/images/pages/homepage/quotes/states-title.svg',
      width: 160,
      height: 110,
      alt: 'States Title'
    },
    img: {
      src: 'http://images.ctfassets.net/1qgw036lpkfx/11Sx6XfAto8onFZTc1zrnA/215bf61afb78ddde35d82ab05d5eecd8/04_3.svg',
      alt: 'States Title',
      width: 1068,
      height: 600
    }
  },
  skydio: {
    content:
      '“We appreciate how the Scale AI team proactively seeks feedback and holds themselves accountable. Their QA team is careful and quick to seek clarification, and their attention to detail has produced some truly impressive results.”',
    profile: 'Rachel Basse',
    position: 'Data Engineer, Skydio',
    logo: {
      src: '/static/images/pages/homepage/quotes/skydio.svg',
      width: 160,
      height: 65,
      alt: 'Skydio'
    }
  },
  standardCognition: {
    content:
      '“It was easy to get started with Scale AI because they had the platform and the people with the skillset to perform the annotation tasks we needed. While we’re much bigger now and could potentially handle the volume of annotation tasks, why would we want to? We believe we should leave data annotation to experts like Scale so we can focus on perfecting the retail shopping experience with regard to the use of AI.”',
    profile: 'Virginia Puccio',
    position: 'Head of Data Operations, Standard Cognition',
    logo: {
      src: '/static/images/pages/homepage/quotes/standard-cognition.svg',
      width: 145,
      height: 80,
      alt: 'Standard Cognition'
    },
    img: {
      src: '/static/img/website/big/customers/cards/standard.jpg',
      alt: 'Standard Cognition',
      width: 1068,
      height: 600
    }
  },
  flexport: {
    content:
      '“One of the benefits of automating this work is that when we send a document to Scale Document AI, we receive the result back in a few minutes. We can detect issues in our supply chain much sooner than we could ever hope to achieve doing this manually.”',
    profile: 'Tom Vu',
    position: 'Head of Data Science and Machine Learning, Flexport',
    logo: {
      src: '/static/images/logos/customers/flexport.svg',
      alt: 'flexport',
      width: 88,
      height: 20
    },
    img: {
      src: '/static/images/customers/flexport.png',
      alt: 'Flexport',
      width: 1200,
      height: 675
    }
  },
  flexport1: {
    content:
      '“Scale’s machine learning-based Document AI is very different from traditional OCR models, or template-based learning. No templates, high quality, and low latency every time. We rely on Scale for document processing, because with higher extraction accuracy, almost zero human labor is required afterward to correct it. With lower latency, we can enable products like air freight where document data has to arrive much faster since air shipments take less than two days.”',
    profile: 'James Chen',
    position: 'Chief Technology Officer, Flexport',
    logo: {
      src: '/static/images/logos/customers/flexport.svg',
      alt: 'flexport',
      width: 88,
      height: 20
    },
    img: {
      src: '/static/images/customers/flexport.png',
      alt: 'Flexport',
      width: 1200,
      height: 675
    }
  },
  brex: {
    content:
      '“Unlike OCR that basically just extracts information and then leaves to our engineers all the work of understanding the context, Scale Document actually figures out the context for us, and that requires minimal work on our side to actually build and integrate the whole pipeline.”',
    profile: 'Henrique Dubugras',
    position: 'Founder and Co-CEO, Brex',
    logo: {
      src: '/static/images/logos/customers/brex.svg',
      alt: 'brex',
      width: 72,
      height: 20
    },
    img: {
      src: '/static/images/customers/brex.png',
      alt: 'Brex',
      width: 1600,
      height: 1025
    }
  },
  nuro: {
    content:
      "“We really value our partnership with Scale and their ability to deliver custom workflows that suit our needs across a variety of mapping and deep learning models. Scale's high-quality, rapidly labeled data will enable us to ramp our map expansion, allowing us to provide more service to customers like Dominos.”",
    profile: 'Eleonor Concepcion',
    position: 'Software Operations Program Manager, Nuro',
    logo: {
      src: '/static/images/pages/homepage/quotes/nuro.svg',
      width: 160,
      height: 75,
      alt: 'Nuro'
    },
    img: {
      src: '/static/img/website/big/customers/cards/nuro.png',
      width: 1872,
      height: 960,
      alt: 'Nuro'
    }
  },
  square: {
    content:
      '“Scale Rapid has made it easier for us to gather annotations at a good price point. The UI is simple to navigate, and the built in worker evaluation pipeline and batch options saves us time and helps enforce best practices so that we can get high-quality training data.”',
    profile: 'Cassandra Ung',
    position: 'Software Engineer, Square',
    logo: {
      src: '/static/images/logos/customers/square.svg',
      width: 160,
      height: 50,
      alt: 'Square'
    }
  },
  uncountable: {
    content:
      '“Scale was able to adapt to admittedly challenging technical specification documents, some containing over 100 annotations for a single document. Scale Rapid helped us quickly adjust our project settings to present even clearer task instructions to labelers. The team at Scale was quick to adopt recommendations into their platform based on our feedback, often within the same day.”',
    profile: 'Isaac Caruso',
    position: 'Data Engineer, Uncountable',
    logo: {
      src: '/static/images/logos/customers/uncountable.svg',
      width: 180,
      height: 50,
      alt: 'Uncountable'
    }
  },
  collectability: {
    content:
      "“Compared with other document annotation platforms we've tested, Scale provided not only a completely polished and well-performing annotation tool, but also offered a complete turnkey solution which included sourcing and managing the annotation workforce, with the results easily accessible via an API. Working with Scale over the past few months has saved us a lot of hassle and substantially accelerated our startup's progress, providing us with invaluable annotated data. Tony/Scale's customer service has assisted us with our rapid iteration so that we could perfect the annotation process, and they have quickly incorporated some of our suggestions to improve their API and platform even further”",
    profile: 'Tom Primozic',
    position: 'CTO, Collectability',
    logo: {
      src: '/static/images/logos/customers/collectability.svg',
      width: 200,
      height: 34,
      alt: 'Collectability'
    }
  },
  timbereye: {
    content:
      "“Properly labeling and counting timber isn't the most common deep learning use case, so we turned to Scale Rapid for our somewhat unique image data labeling needs. Scale's team was able to adapt to our requirements and deliver high-quality labeled data on schedule. Scale Rapid removes the pain and time burden of manually labeling data on a tight timeframe!”",
    profile: 'Scott Gregg',
    position: 'CEO and Founder, TimberEye',
    logo: {
      src: '/static/images/logos/customers/timbereye.svg',
      width: 166,
      height: 42,
      alt: 'TimberEye'
    }
  },
  x2: {
    content:
      '“At X2, it became clear that our test users ask a very wide range of questions. We needed to classify this wide array of questions, and check for the performance of our model in answering them. We turned to Scale Rapid for quick turnaround time and robust results thanks to their helpful user interface and quick adjustments to our labeling instructions to handle edge cases specific to our users’ needs.”',
    profile: 'Chakshu Ahuja',
    position: 'Engineering Lead, X2.ai',
    logo: {
      src: '/static/images/logos/customers/x2.svg',
      width: 60,
      height: 80,
      alt: 'X2'
    }
  },
  grata: {
    content:
      '“Scale Rapid truly stands out from other data labelling solutions in the market. We used it for text categorization and were impressed by the turnaround time and thoughtful design of the workflow for taxonomy creation,  quality lab and built-in metrics for auditing along with the other features such as API access, price estimator, etc. which together make it a great self-serve solution.”',
    profile: 'Nikhil Raju',
    position: 'Senior ML Engineer, Grata',
    logo: {
      src: '/static/images/logos/customers/grata.svg',
      width: 144,
      height: 60,
      alt: 'Grata'
    }
  },
  keeptruckin: {
    content:
      '“KeepTruckin encounters all manners of surprising edge cases in real world data collection, so when it comes to knowing we’re labeling the most valuable subset of our collected data, we turn to Scale Nucleus. Its intuitive visualizations, query engine and Autotag help our teams improve both data quality and models, all in the same motion.”',
    profile: 'Ali Rehan',
    position: 'Engineering Manager AI/Vision Products, KeepTruckin',
    logo: {
      src: '/static/images/pages/homepage/logos/keeptruckin.svg',
      width: 200,
      height: 50,
      alt: 'KeepTruckin'
    }
  },
  embark: {
    content:
      '“Scale is a critical part of our stack, providing both software & trained resources to label our LIDAR and camera data with extremely high quality. When the team comes to me with new projects, I’m always confident that Scale will meet our needs & timelines.”',
    profile: 'Brandon Moak',
    position: 'CTO, Embark',
    logo: {
      src: '/static/images/pages/homepage/logos/embark.svg',
      width: 162,
      height: 47,
      alt: 'Embark'
    }
  },
  voyage: {
    content:
      '“Scale has a team of very talented engineers who really understand the problems in training machine learning models, of data annotation, and of data quality.”',
    profile: 'Oliver Cameron',
    position: 'Cofounder, Voyage',
    logo: {
      src: '/static/images/pages/homepage/logos/voyage.svg',
      width: 157,
      height: 40,
      alt: 'Voyage'
    }
  },
  seaMachines: {
    content:
      '“Scale AI has been a critical part of our AI development cycle: its powerful data platform fits into our data pipeline seamlessly providing efficient annotations for large volumes of data, its talented engineering and QA teams help delivering high quality of challenging data, and its customer operations team work very closely with us to help reaching our development goal successfully and smoothly.”',
    profile: 'Fiona Hua',
    position: 'Lead Perception Engineer, Sea Machines Robotics',
    logo: {
      src: '/static/images/logos/customers/seamachines.svg',
      width: 200,
      height: 43,
      alt: 'Sea Machines'
    },
    img: {
      src: '/static/img/website/big/customers/cards/seamachines.jpg',
      alt: 'Sea Machines',
      width: 1068,
      height: 600
    }
  },
  openAI: {
    content:
      '“OpenAI threw a bunch of tasks at Scale AI with difficult characteristics, including tight latency requirements and significant ambiguity in correct answers. In response, Scale worked closely with us to adjust their QA systems to our needs.”',
    profile: 'Geoffrey Irving',
    position: 'Member of Technical Staff, OpenAI',
    logo: {
      src: '/static/images/logos/customers/openai.svg',
      width: 149,
      height: 36,
      alt: 'OpenAI'
    },
    img: {
      src: '/static/img/website/big/customers/cards/openai.jpg',
      alt: 'OpenAI',
      width: 1068,
      height: 600
    }
  },
  lyft: {
    content:
      '“Scale is basically providing the ground truth for our perception systems. It’s a very, very critical piece for us to develop.”',
    profile: 'Anantha Kancherla',
    position: 'Head of self driving software, Lyft',
    logo: { src: '/static/images/pages/homepage/quotes/lyft.svg', width: 118, height: 80 },
    img: {
      src: '/static/img/website/big/customers/cards/lyft.jpg',
      width: 1068,
      height: 600,
      alt: 'Lyft'
    }
  },
  doma: {
    logo: {
      src: '/static/images/pages/homepage/logos/doma.svg',
      alt: 'Doma Logo',
      width: 100,
      height: 82
    },
    content:
      '“Scale has provided the fuel to put our machine learning systems on overdrive. They make sure the highest quality training data is there in time to meet our aggressive roadmap. Lenders and borrowers will experience faster and more efficient closings sooner as a result.”',
    profile: 'Andy Mahdavi',
    position: 'Chief Data Science Officer, Doma',
    img: {
      src: '/static/img/website/big/customers/cards/doma.jpg',
      alt: 'Doma Image'
    }
  },
  kodiak: {
    logo: {
      src: '/static/images/logos/customers/kodiak.svg',
      alt: 'Kodiak Logo',
      width: 93,
      height: 89
    },
    content:
      '“Kodiak uses synthetic data not as an alternative to real-world data, but as a complement; Scale Synthetic is an important enabler of that approach. By using Scale Synthetic to efficiently generate a large number of rare edge cases, the Kodiak Driver leverages the best of both real and synthetic data. Everything integrates seamlessly with our existing data labeling pipeline and data”',
    profile: 'Derek Phillips',
    position: 'Senior Software Engineer, Kodiak Robotics'
  },
  magna: {
    content:
      '“Once our data was uploaded, we were able to train, validate and deploy 3 classifiers to our full dataset to identify police cars, ambulances, and firetrucks in just 4 hours, identifying a large number of these rarer case images to send to labeling. This process would have taken weeks without Nucleus.”',
    profile: 'Varun Sundar Rabindranath',
    position: 'ML and Perception Engineer, Magna International',
    logo: {
      src: '/static/images/pages/homepage/logos/magna.svg',
      width: 250,
      height: 51,
      alt: 'Magna'
    }
  }
};
